import React, { useContext, useMemo } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { aggregateData } from '../functions';
import GraphTable from '../mechanisms/graphtable';
import { formatCurrency } from '../functions';
import { currencyPrefix } from '../single-card';
import { DashboardContext } from '../mechanisms/card';
import DashView from '../mechanisms/dashview';
import dayjs from 'dayjs'
import { convert_seconds } from '../../Dash/HistoricDash/graphs/charts';

const DelayedSales = ({ data }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => {
        const agg_data = aggregateData('value', data.flatMap(d => {
            if (['ACTIVE', 'QUALIFIED'].includes(d.status) && dayjs(d.estimated_at) < dayjs()) {
                d.duration = (dayjs().unix() - dayjs(d.estimated_at).unix()) || 0
                return [d]
            }
            return []

        }), 'owner_id')
        agg_data.forEach(row => {
            row.duration = row.duration / (row.count || 1)
        })
        return agg_data
    }
        , [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'owner_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor não conquistado', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                },
                {
                    field: 'duration', headerName: 'Tempo médio de atraso', flex: 1,
                    renderCell: ({ value }) => convert_seconds(value)
                }
            ]} />
                : <DashView name='delayedsales' rows={graph} vx={'owner_name'} vy={['value', 'count', 'duration']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    else if (vy === 'duration')
                        return convert_seconds(row[vy] / (row.count || 1))
                    return row[vy]
                }} />
            }
        </>
    );
}


export default DelayedSales